import { concat, keyBy } from 'es-toolkit/compat';

import { MultiChipSelect } from 'ui';

interface Props {
  selectedOptionKeys: Array<string | number>;
  allOptionGroups: SelectOption[][];
  onChange(changedOption: SelectOption): void;
  inputLabel: string;
  id: string;
}

const SelectedOptionsList = ({
  allOptionGroups,
  selectedOptionKeys,
  onChange,
  inputLabel,
  id,
}: Props) => {
  const allOptions = concat([], ...allOptionGroups);
  const allSelectOptionsByKey = keyBy(allOptions, 'key');
  const selectedOptions = selectedOptionKeys.map(
    (selectedOptionKey) => allSelectOptionsByKey[selectedOptionKey]
  );

  const handleChange = (item: SelectOption) => {
    onChange(item);
  };

  return (
    <div className="SelectedOptionsList">
      <MultiChipSelect
        onChange={handleChange}
        itemGroups={allOptionGroups}
        selectedItems={selectedOptions}
        inputLabel={inputLabel}
        id={id}
      />
    </div>
  );
};

export default SelectedOptionsList;
